import styled from "styled-components";
import { tokens } from "../../../../public/tokens";

const { colors, typography, globals } = tokens;

/**
 * A table row's primary/title cell rendered as a link — bold foreground text (not link-blue),
 * underlining only on hover. Not tied to `StyledTd`'s padding/height since callers (e.g. custom
 * multi-tbody tables like Study Paths) don't all use `StyledTd` for their cells.
 */
export const StyledTableLink = styled.a({
    color: colors.text.primary,
    fontFamily: typography.fontFamilies["albert-sans"],
    fontSize: typography.fontSize["lg-14px"],
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights["110"],
    textDecoration: "none",
    cursor: "pointer",

    "&:hover": {
        textDecoration: "underline",
    },
});

export const StyledExpandableList = styled.ul({
    margin: 0,
    padding: 0,
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: globals["spacing-1"],
});

export const StyledExpandableListItem = styled.li({
    display: "flex",
    alignItems: "flex-start",
    gap: globals["spacing-1-5"],
    fontFamily: typography.fontFamilies["albert-sans"],
    fontSize: typography.fontSize["lg-14px"],
    color: colors.text.primary,

    "&::before": {
        content: '"•"',
        color: colors.text.link,
        fontWeight: typography.fontWeights.bold,
        lineHeight: typography.lineHeights["100"],
    },
});

export const StyledExpandableListToggle = styled.button({
    alignSelf: "flex-start",
    margin: 0,
    padding: 0,
    border: "none",
    background: "none",
    fontFamily: typography.fontFamilies["albert-sans"],
    fontSize: typography.fontSize["lg-14px"],
    fontWeight: typography.fontWeights.semibold,
    color: colors.text.link,
    cursor: "pointer",
});
